import { render, staticRenderFns } from "./ModalCarousel.vue?vue&type=template&id=c5c0039c&"
import script from "./ModalCarousel.vue?vue&type=script&lang=js&"
export * from "./ModalCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports